import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2aa989eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "merge-customer-table" }
const _hoisted_2 = {
  key: 0,
  class: "pi icon-lms icon-lms_link",
  style: {"color":"#07b53b"}
}

import { withDefaults, ref, watch, computed } from "vue";

type IProps = {
  items?: any;
  selectMultiple?: boolean;
  searchAllPlaceHolder?: string;
  selectedCustomers?: any;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'customer-table',
  props: {
    items: null,
    selectMultiple: { type: Boolean, default: false },
    searchAllPlaceHolder: { default: "名前・電話番号・生年月日" },
    selectedCustomers: null
  },
  emits: ["toggle", "data-change"],
  setup(__props: any, { emit: emits }) {

const props = __props as { items?: any, selectMultiple: boolean, searchAllPlaceHolder: string, selectedCustomers?: any };

const columns = [
  { field: "code", header: "カルテNo.", style: "width: 15%" },
  {
    field: "name",
    header: "名前",
    class: "white-space-nowrap overflow-hidden text-overflow-ellipsis",
    style: "width: 35%",
  },
  { field: "phone", header: "電話番号", style: "width: 15%" },
  { field: "birthday", header: "生年月日", style: "width: 15%" },
];



const selectionMode = computed(() => (props.selectMultiple ? "multiple" : "single"));



const currentSelectedCustomers = ref(props.selectedCustomers);

const onRowClick = (event: any) => {
  if (!props.selectMultiple) {
    currentSelectedCustomers.value = event.data;
  }
};
watch(
  () => currentSelectedCustomers.value,
  value => emits("data-change", value, props.selectMultiple)
);
watch(
  () => props.items,
  value => {
    currentSelectedCustomers.value = currentSelectedCustomers?.value?.filter(c => value.includes(c));
  }
);

return (_ctx: any,_cache: any) => {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      value: __props.items,
      tableClass: "w-full",
      scrollable: "",
      scrollHeight: "flex",
      onRowClick: onRowClick,
      selection: currentSelectedCustomers.value,
      "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((currentSelectedCustomers).value = $event))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "title")
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode("データがありません")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          selectionMode: _unref(selectionMode),
          style: {"width":"5%"}
        }, null, 8, ["selectionMode"]),
        _createVNode(_component_Column, {
          field: "lineAccount",
          header: "LINE紐付け",
          class: "flex justify-content-center",
          style: {"width":"15%"}
        }, {
          body: _withCtx(({ data }) => [
            (data.linked_line)
              ? (_openBlock(), _createElementBlock("i", _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
          return _createVNode(_component_Column, {
            key: col.field,
            field: col.field,
            header: col.header,
            class: _normalizeClass(col.class),
            style: _normalizeStyle(col.style)
          }, null, 8, ["field", "header", "class", "style"])
        }), 64))
      ]),
      _: 3
    }, 8, ["value", "selection"])
  ]))
}
}

})